/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global lng */

function FormExportXmlBuilder() {
  if (!this instanceof FormExportXmlBuilder) return new FormExportXmlBuilder();

  var that = this;

  this.node;
  this.formSchema;

  this.loadFormSchema = loadFormSchema;
  this.load = load;
  this.getJson = getJson;
  this.onclose = (json) => console.warn("onclose() should be overwriten");
  this.oncancel = () => console.warn("oncancel() should be overwriten");

  this.node = document.createElement("div");
  this.node.classList.add("formExportCsv-builder");
  this.node.insertAdjacentHTML(
    "beforeend",
    `
        <div class="export">
            <div class="control-bar">
                <i class="ok material-icons">save</i>
                <i class="close material-icons">close</i>
                <h3>${lng.get("xmlform-export-configuration")}</h3>
            </div>
            <div class="infobox">
                ${lng.get("xmlform-export-information")}
            </div>
                <textarea class="customerXML"></textarea>
        </div>
        <div class="blueprints">
            <div class="control-bar">
                <h3>${lng.get("xmlform-export-preform")}</h3>
            </div>
            <table class="blueprints-table">
            </table>
        </div>
    `
  );

  /**
   * @type Element
   */
  var customerXML = this.node.querySelector("textarea.customerXML");
  customerXML.placeholder =
    "<customer_$$customerID$$>\n\t<customer-purchase-order-date>\n\t\t$$trackdate$$ $$tracktime$$\n\t</customer-purchase-order-date>\n\t...\n</customer_$$customerID$$>";
  customerXML.onkeydown = function (event) {
    if (event.keyCode === 9) {
      var val = this.value,
        start = this.selectionStart,
        end = this.selectionEnd;
      this.value = val.substring(0, start) + "\t" + val.substring(end);
      this.selectionStart = this.selectionEnd = start + 1;
      return false;
    }
  };
  /**
   * @type Element
   */
  var blueprints = this.node.querySelector(".blueprints");
  var blueprintsTable = this.node.querySelector(".blueprints-table");
  /**
   * @type Element
   */

  var saveButton = this.node.querySelector("i.ok");
  var cancelButton = this.node.querySelector("i.close");

  cancelButton.addEventListener("click", function (e) {
    that.node.parentNode.removeChild(that.node);
    that.oncancel();
  });

  saveButton.addEventListener(`click`, function (e) {
    var data = getJson();
    that.onclose(data);
    that.node.parentNode.removeChild(that.node);
  });

  /**
   *
   * @param {string} schema
   * @returns {undefined}
   */
  function loadFormSchema(schema) {
    schema = JSON.parse(schema);
    that.formSchema = schema;
    var nodes = [];

    FormExportXmlBuilder.reserved.map((r) =>
      nodes.push(genSchemaItemNode(r, "", r))
    );
    schema.map((schemaItem) => {
      switch (schemaItem.type) {
        case "image":
        case "sign":
        case "hr":
          //ignore
          return;
        case "text":
          var key = schemaItem.meta.name;
          if (schemaItem.meta.checkbox) {
            nodes.push(
              genSchemaItemNode("text", keyToLabel(key), key + "." + key)
            );
          }
          break;
        case "textArea":
          var key = schemaItem.meta.name;
          nodes.push(genSchemaItemNode("textArea", keyToLabel(key), key));
          break;
        case "multichoice":
          var key = schemaItem.meta.name;
          nodes.push(genSchemaItemNode("multichoice", keyToLabel(key), key));
          break;
        case "raffle":
          var key = schemaItem.meta.name;
          nodes.push(genSchemaItemNode("raffle", keyToLabel(key), key));
          break;
        case "tel":
          var telKeys = ["mobiletel", "festtel"];
          if (schemaItem.meta.vorwahl)
            telKeys = ["vwmobile", "mobiletel", "vwfest", "festtel"];
          telKeys.map((telKey) => {
            var key = schemaItem.meta.name + "." + telKey;
            nodes.push(genSchemaItemNode("tel", keyToLabel(key), key));
          });
          break;
        case "address":
          var addressKeys = [
            "postalCode",
            "city",
            "street",
            "houseNumber",
            "houseNumberExtra",
          ];
          if (schemaItem.meta.epaper)
            addressKeys = [
              "postalCode",
              "city",
              "street",
              "houseNumber",
              "houseNumberExtra",
              "print",
              "epaper",
            ];
          addressKeys.map((addrKey) => {
            var key = schemaItem.meta.name + "." + addrKey;
            nodes.push(
              genSchemaItemNode(
                "address",
                keyToLabel(key), //example: Zustelladresse: Hausnummer
                key
              )
            ); //example: deliveryAddress.houseNumber
          });
          break;
        case "default":
          schemaItem.data.map((defaultItem) => {
            var key = schemaItem.meta.name + "." + defaultItem.name;
            nodes.push(
              genSchemaItemNode(
                "default",
                keyToLabel(key), //example: Name: Vorname
                key
              )
            ); //example: name.firstname
          });
          break;
        default:
          console.error(`Type ${schemaItem.type} not implemented`);
      }
    });

    requestAnimationFrame(() => {
      var header = document.createElement("tr");
      header.insertAdjacentHTML(
        "beforeend",
        `<td class="table-header">${lng.get(
          "formExportXml-table-label"
        )}</td><td class="table-header">${lng.get(
          "formExportXml-table-keyLabel"
        )}</td>`
      );
      blueprintsTable.appendChild(header);
      nodes.map((n) => {
        n.classList.add("xml-item");
        blueprintsTable.appendChild(n);
      });
    });
  }

  function load(data) {
    customerXML.value = JSON.parse(data);
  }

  function getJson() {
    return JSON.stringify(customerXML.value);
  }

  /**
   * Generate a draggable node.
   * @param {string} text for label
   * @param {string} key key pattern to identify in form
   * use <i>empty</i> to create a spacer column.
   * @param {string} value
   * the prefixvalue for euch item in the column
   * @param {number} n
   * For 'key=empty' and address (to set the prefix or not)
   * * @returns {Element}
   */
  function genSchemaItemNode(type, text, key) {
    var schemaNode = document.createElement("tr");
    schemaNode.text = text;
    schemaNode.key = key;

    var labelTd = document.createElement("td");
    var keyLabelTd = document.createElement("td");

    var label = document.createElement("label");
    var keyLabel = document.createElement("label");

    label.textContent = text;
    label.key = key;
    label.type2 = type;
    keyLabel.textContent = `$$${key}$$`;
    if (FormExportCsvBuilder.reserved.indexOf(key) !== -1) {
      label.textContent = lng.get("formExport-reserved_" + key);
      keyLabel.textContent = lng.get("formExport-reserved-keylabel_" + key);
    }

    labelTd.appendChild(label);
    keyLabelTd.appendChild(keyLabel);
    keyLabelTd.addEventListener("click", (e) => {
      var label;
      if (e.srcElement.nodeName === "LABEL") {
        label = e.srcElement;
      } else if (e.srcElement.nodeName === "TD") {
        label = e.srcElement.firstChild;
      }
      if (label) {
        var range;
        if (document.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(label);
          range.select();
        } else if (window.getSelection) {
          const selection = window.getSelection();
          range = document.createRange();
          range.selectNodeContents(label);
          selection.removeAllRanges();
          selection.addRange(range);
        } else {
          console.warn("Could not select text in node: Unsupported browser.");
        }
        var successful = document.execCommand("copy");
        if (successful) {
          snackbar.show({
            message: lng.get("formExport-copy-variable") + label.innerHTML,
            time: 1,
          });
        }
      }
    });
    schemaNode.appendChild(labelTd);
    schemaNode.appendChild(keyLabelTd);
    return schemaNode;
  }

  function keyToLabel(key) {
    var schema = that.formSchema;
    var keyParts = key.split("."); //currently max length is 2

    var schemaItem;

    for (var i = 0, len = schema.length; i < len; i++) {
      var item = schema[i];
      if (item.meta.name === keyParts[0]) {
        schemaItem = item;
        break;
      }
    }

    if (!schemaItem) return;

    switch (schemaItem.type) {
      case "image":
      case "sign":
        //ignore
        return;
      case "raffle":
      case "multichoice":
      case "textArea":
      case "text":
        return schemaItem.meta.name;
      case "address":
        var addressKey = keyParts[1];
        if (schemaItem.meta.name)
          return (
            schemaItem.meta.name +
            ": " +
            lng.get("form-input-address-" + addressKey)
          );
        return lng.get("form-input-address-" + addressKey);
      case "tel":
        var telKey = keyParts[1];
        if (schemaItem.meta.name)
          return (
            schemaItem.meta.name + ": " + lng.get("form-input-tel-" + telKey)
          );
        return lng.get("form-input-tel-" + telKey);
      case "default":
        var secondKey = keyParts[1];
        var defaultData = schemaItem.data;
        for (var i = 0, len = defaultData.length; i < len; i++) {
          var defaultItem = defaultData[i];
          if (defaultItem.name === secondKey) {
            if (schemaItem.meta.name)
              return schemaItem.meta.name + ": " + defaultItem.name;
            return defaultItem.name;
          }
        }
        break;
      default:
        console.error(`Type ${schemaItem.type} not implemented`);
    }
  }
}

Object.defineProperty(FormExportXmlBuilder, "reserved", {
  //Important!! Sync this with CustomerService.js, but only those who are per customer
  value: [
    "location",
    "marketnumber",
    "employee",
    "employeenumber",
    "date",
    "time",
    "customerid",
  ],
});
